import type { EnrollmentCreateFailedResult } from './enrollmentCreateFailedResult';

export interface EnrollmentCreateFailed {
  /** 에러 코드 */
  errorCode: string;
  /** 실패 사유 */
  reason: string;
  result: EnrollmentCreateFailedResult;
}
